import React from "react";

export { AddCircular } from './AddCircular';

export { ArrowRight } from './ArrowRight';
export { CheckCircular } from './CheckCircular';
export { PlusCircular } from './PlusCircular';
export { Cube } from './Cube';
export { Embed } from './Embed';
export { Plus } from './Plus';
export { Refresh } from './Refresh';
export { Upload } from './Upload';
export { ChevronRight } from './ChevronRight';
export { Search } from './Search';
export { Copy } from './Copy';
export { Invoice } from './Invoice';
export { Trash } from './Trash';
export { ChevronDown } from './ChevronDown';
export { ChevronLeft } from './ChevronLeft';
export { More } from './More';
export { Close } from './Close';
export { Info } from './Info';
export { Settings } from './Settings';
export { Tag } from './Tag';
export { ChevronUp } from './ChevronUp';
export { Delete } from './Delete';
export { Download } from './Download';
export { Star } from './Star';
export { DefaultMark } from './DefaultMark';

export const CSVIcon = () => <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.6667 2.5V5.83333C11.6667 6.05435 11.7545 6.26631 11.9108 6.42259C12.0671 6.57887 12.2791 6.66667 12.5001 6.66667H15.8334" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.58341 17.5H5.83341C5.39139 17.5 4.96746 17.3244 4.6549 17.0118C4.34234 16.6993 4.16675 16.2754 4.16675 15.8333V4.16667C4.16675 3.72464 4.34234 3.30072 4.6549 2.98816C4.96746 2.67559 5.39139 2.5 5.83341 2.5H11.6667L15.8334 6.66667V10.8333M11.6667 15.8333H17.5001M17.5001 15.8333L15.0001 13.3333M17.5001 15.8333L15.0001 18.3333" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;

const EditIcon = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.33325 16.6643H6.66659L15.4166 7.91431C15.8586 7.47229 16.1069 6.87277 16.1069 6.24765C16.1069 5.62253 15.8586 5.02301 15.4166 4.58098C14.9746 4.13895 14.375 3.89063 13.7499 3.89063C13.1248 3.89062 12.5253 4.13895 12.0833 4.58098L3.33325 13.331V16.6643Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.25 5.41406L14.5833 8.7474" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

const CopyIcon = () => <svg width="20" height="20" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 8.5H10C8.89543 8.5 8 9.39543 8 10.5V18.5C8 19.6046 8.89543 20.5 10 20.5H18C19.1046 20.5 20 19.6046 20 18.5V10.5C20 9.39543 19.1046 8.5 18 8.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 8.5V6.5C16 5.96957 15.7893 5.46086 15.4142 5.08579C15.0391 4.71071 14.5304 4.5 14 4.5H6C5.46957 4.5 4.96086 4.71071 4.58579 5.08579C4.21071 5.46086 4 5.96957 4 6.5V14.5C4 15.0304 4.21071 15.5391 4.58579 15.9142C4.96086 16.2893 5.46957 16.5 6 16.5H8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;